/* @flow */

import type { PointsPrice, Price } from "helpers/points";

import React from "react";
import useFormat from "helpers/hooks/use-format";
import { getPriceSplit } from "helpers/points";
import { useTranslate } from "@awardit/react-use-translate";

type Props = {
  pointsPrice?: ?PointsPrice,
  price?: ?Price,
  className?: string,
};

const PriceSplit = ({ pointsPrice, price, className }: Props): React$Node => {
  const t = useTranslate();
  const { formatPoints, formatPrice } = useFormat();
  const priceSplit = getPriceSplit(pointsPrice, price);

  if (!priceSplit) {
    return null;
  }

  const renderSplit = (s, i) => {
    switch (s.type) {
      case "points":
        return (
          <div key={i}>
            {i > 0 && <span>{t("OR")}&nbsp;</span>}
            <span>{formatPoints(s.values.points || 0)}</span>
          </div>
        );
      case "currency":
        return (
          <div key={i}>
            {i > 0 && <span>{t("OR")}&nbsp;</span>}
            <span>{formatPrice(s.values.currency || 0)}</span>
          </div>
        );
      case "split":
        return (
          <div key={i}>
            {i > 0 && <span>{t("OR")}&nbsp;</span>}
            <span>
              <span>{formatPoints(s.values.points || 0)}</span>
              <span>&nbsp;+&nbsp;{formatPrice(s.values.currency || 0)}</span>
            </span>
          </div>
        );
      default:
    }
  };

  return (
    <div className={className}>
      {priceSplit.map(renderSplit)}
    </div>
  );
};

export default PriceSplit;
